import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';

export interface PushRecentFailuresRow {
  user_id: string;
  email: string;
  notification_type: string;
  error_code: number | null;
  error_message: string | null;
  created_at: string;
  endpoint_preview: string;
}

export const PushRecentFailures: Entity<PushRecentFailuresRow> = {
  id: 'PushRecentFailures',
  title: 'Push Recent Failures',
  service: 'main',
  rowLabel: (row: PushRecentFailuresRow) => `${row.email} - ${row.notification_type} (${row.error_code})`,
  primaryKeyFields: ['user_id', 'created_at', 'endpoint_preview'],
  source: {
    tableName: 'public.push_recent_failures',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['created_at', 'DESC']],
  defaultFilters: [],
  fields: {
    user_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'User',
      refEntity: UserView,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    email: {
      seq: 10,
      type: FieldType.Text,
      label: 'Email',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    notification_type: {
      seq: 15,
      type: FieldType.Options,
      label: 'Type',
      listColumn: true,
      options: [
        { id: 'message', label: 'Message' },
        { id: 'test', label: 'Test' },
        { id: 'system', label: 'System' },
        { id: 'reminder', label: 'Reminder' },
        { id: 'alert', label: 'Alert' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    error_code: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Error Code',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    error_message: {
      seq: 25,
      type: FieldType.Text,
      label: 'Error Message',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
    },
    created_at: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'Failed At',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    endpoint_preview: {
      seq: 35,
      type: FieldType.Text,
      label: 'Endpoint Preview',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
